/** @jsxImportSource @emotion/react */
import * as React from "react";
import BoxedMessage from "./BoxedMessage";
import { css, SerializedStyles } from "@emotion/react";
import { BoxedMessageStyle } from "./boxedMessageStyle";
import { BoxedErrorMessageDefault } from "./boxedMessageStyles";

/**
 * StyledBoxMessage
 * This is a wrapper for BoxMessage and allows you to pass in a custom or preset BoxedMessageStyle
 * object as a parameter. Preset styles (such as success and error) can be found in:
 * constants/layout/boxMessageStyles.tsx
 *
 * @param message - The message to display
 * @param onClose - Function to run on close (if not supplied, close button is hidden)
 * @param boxStyle - Optional. The BoxedMessageStyle to apply. Default: BoxedErrorMessageDefault
 * @param extraCss - Optional. Any additional class styling to apply. Default: none
 */
export const StyledBoxedMessage: React.FC<{
  message?: string | React.ReactNode;
  onClose?: () => void;
  boxStyle?: BoxedMessageStyle;
  extraCss?: SerializedStyles;
}> = ({ message, onClose, boxStyle = BoxedErrorMessageDefault, extraCss }) => (
  <BoxedMessage
    imgAlt={boxStyle.imgAlt}
    image={boxStyle.image}
    backgroundColor={boxStyle.backgroundColor}
    textColor={boxStyle.textColor}
    message={message}
    onClose={onClose}
    rootCss={css`
      ${boxStyle.rootCss};
      ${extraCss};
    `}
  />
);
